import React, { useMemo, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import Tags, { getTag } from '../../common/Tags';
import { AppliedCouponTag } from '../../common/Tags/defaultTags';
import PixDiscountTag from './PixDiscountTag';

import { formatPrice } from '../../../utils';
import {
  sendToRDStation,
  getProductPurchaseUrl,
  selectPlanAndRedirect,
  getProductPlanUrl,
  insertTagPurchaseUrl
} from '../../../utils/plan';

const codeTagSpecialistIndicator = '70';

const Plan = (props) => {
  const { match, plan, providers, isSelected, position, openModalQuotationDateWarning, addComparisonPlan, showSpecialistSuggestions, paymentMethods } = props;

  const productUrl = useMemo(() => getProductPlanUrl(match, plan.code), [match, plan.code]);
  const productPurchaseUrl = useMemo(() => getProductPurchaseUrl(match, plan.code), [match, plan.code]);


  const pixDiscountMultiplier = useMemo(() => {
    if (paymentMethods && paymentMethods.length > 0) {
      const pixPayment = paymentMethods.find(method => method.slug === 'pix');
      if (pixPayment && pixPayment.discount > 0) {
        return (100 - pixPayment.discount) / 100;
      }
    }
    return 0.95;
  }, [paymentMethods]);

  const selectPlan = useCallback(async () => {
    sendToRDStation();

    if (plan.extra.specialist_indicator && showSpecialistSuggestions) {

      const url = insertTagPurchaseUrl(productPurchaseUrl, codeTagSpecialistIndicator);
      return selectPlanAndRedirect(url);
    }

    selectPlanAndRedirect(productPurchaseUrl);
  }, [openModalQuotationDateWarning, productPurchaseUrl]);

  const provider = useMemo(
    () => providers.find((provider) => provider.code === plan.provider_code),
    [providers, plan.provider_code]
  );
  const providerImgPath = provider ? `/assets/images/seguradoras/${provider.slug}.png` : '';

  const benefits = useMemo(() => {
    const baggage = plan.benefits.find((benefit) => benefit.code === '42' || benefit.code === 42);
    const hospital = plan.benefits.find((benefit) => benefit.code === '51' || benefit.code === 51);
    return { baggage, hospital };
  }, [plan.benefits]);

  const tag = getTag(plan);

  const isSpecialist = plan.extra.specialist_indicator && showSpecialistSuggestions;

  return (
    <div className={`box-plans${isSpecialist ? ' specialist' : ''}${isSelected ? ' selecionado' : ''}${position === 0 ? ' first-box' : ''}`}>
      <div className={`specialist-box${isSpecialist ? ' show' : ' hide'}`}>👨‍💻 Recomendação do especialista</div>
      <div className={`triangle-topleft${isSelected ? '' : ' hide'}${position === 0 ? ' first-box' : ''}`}>
        <img className="selecionado-ico" src="/assets/images/selecionado-ico.svg" alt="Selecionado" />
      </div>

      <Tags tag={tag} isMobile customClassName="search-box-tag" />

      <div className={`box-body-plans${tag ? '' : ' no-tag'}`}>
        <div className="box-container-image">
          <img onClick={selectPlan} src={providerImgPath} alt="" />
        </div>

        <div className="box-container-plan-info">
          <Tags tag={tag} isMobile={false} customClassName="search-box-tag" />

          <div className="box-plan-row">
            <div className="names-plans" onClick={selectPlan}>
              {plan.name}
            </div>
            <div className="prices-high">
              Faixa etária: {plan.child.min_age} a {plan.elder.max_age} anos <br />
              {plan.elder.min_age < plan.elder.max_age && (

                `R$ ${formatPrice(plan.elder.price)} maiores de ${plan.adult.max_age} anos`

              )}
            </div>
          </div>

          <div className="box-plan-link desktop">
            <Link to={productUrl} className="url-roof" data-cy={`link-ver-cobertura-completa-p${position}`}>
              Ver a cobertura completa
            </Link>
          </div>
        </div>

        <div className={`box-plan-values${tag ? ' with-tag' : ''}`}>
          <div className="infos-plans">
            <strong>Despesa Médica Hospitalar total</strong>
            <div>{benefits.hospital && benefits.hospital.coverage || 'N/A'}</div>
          </div>

          <div className="infos-plans">
            <strong>Seguro bagagem</strong>
            <div>{benefits.baggage && benefits.baggage.coverage || 'N/A'}</div>
          </div>
        </div>
      </div>

      <div className="box-body-plan-values-mobile">
        <div className="infos-plans">
          <strong>Despesa Médica Hospitalar total</strong>
          <div>{benefits.hospital && benefits.hospital.coverage || 'N/A'}</div>
        </div>

        <div className="infos-plans">
          <strong>Seguro bagagem</strong>
          <div>{benefits.baggage && benefits.baggage.coverage || 'N/A'}</div>
        </div>

        <div className="box-plan-link">
          <Link to={productUrl} className="url-roof" data-cy={`link-ver-cobertura-completa-p${position}`}>
            Ver a cobertura completa
          </Link>
        </div>
      </div>

      <div className="box-footer-plans">
        {plan.price_with_coupon_discount ? (
          <React.Fragment>
            <Tags tag={AppliedCouponTag} isMobile customClassName="search-applied-coupon" />
            <Tags tag={AppliedCouponTag} isMobile={false} customClassName="search-applied-coupon" />
            <span className="old-price">R$ {formatPrice(plan.adult.price)}</span>
          </React.Fragment>
        ) : null}

        <div className={`box-footer-price-details${plan.price_with_coupon_discount ? ' with-coupon-tag' : ''}`}>
          <div>
            <span className="price-atually">
              <b>R$ {formatPrice(plan.price_with_coupon_discount || plan.adult.price)}</b> {plan.parcels || 1}x sem juros no cartão
            </span>
            <div className="price-pix">
              <span>
                R$ {formatPrice((plan.price_with_coupon_discount || plan.adult.price) * pixDiscountMultiplier)}
              </span>
              <PixDiscountTag />
            </div>
            <span className="price-person">/ preço por pessoa</span>
          </div>
          <div className="action-buttons">
            <label htmlFor={`compare-button${plan.code}`} className="compare-button">
              <input
                type="checkbox"
                defaultChecked={isSelected}
                id={`compare-button${plan.code}`}
                onClick={() => addComparisonPlan(plan)}
                data-cy={`botao-comparar-p${position}`}
              />
              Comparar Plano
            </label>
            <a className="select-button" onClick={selectPlan} data-cy={`botao-selecionar-seguro-p${position}`}>
              Selecionar seguro
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(
  (state) => ({
    paymentMethods: state.purchase.paymentMethods,
  })
)(Plan);



// WEBPACK FOOTER //
// ./src/components/search/plans_table/Plan.jsx